import { z } from "zod";

export const ServiceItemGroupSchema = z.object({
  label: z.string().min(1).max(80),
});

export type ServiceItemGroupDto = z.infer<typeof ServiceItemGroupSchema>;

/** Nouvel ordre des groupes et affectation/ordre des services (glisser-déposer). */
export const ReorderServiceItemGroupsSchema = z.object({
  groups: z.array(
    z.object({
      id: z.string(),
      position: z.number().int(),
    }),
  ),
  items: z.array(
    z.object({
      id: z.string(),
      groupId: z.string().nullable(),
      position: z.number().int(),
    }),
  ),
});

export type ReorderServiceItemGroupsDto = z.infer<
  typeof ReorderServiceItemGroupsSchema
>;
